import React, { useCallback, useRef, useState } from 'react';

import { Box, Typography, Button, CircularProgress } from '@mui/material';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';



const ACCEPT =

  '.pptx,.png,.jpg,.jpeg,.gif,.webp,.bmp,.svg,image/*,application/vnd.openxmlformats-officedocument.presentationml.presentation';



export default function SlideAssetZone({

  onFiles,

  onGerarImagem,

  disabled,

  importing,

  generatingImage,

  showIlustracaoHint = true,
  variant = 'light',
}) {

  const inputRef = useRef(null);

  const [dragOver, setDragOver] = useState(false);



  const processList = useCallback(

    async (fileList) => {

      const files = Array.from(fileList || []).filter(Boolean);

      if (!files.length || !onFiles) return;

      await onFiles(files);

    },

    [onFiles]

  );



  const onDrop = useCallback(

    (e) => {

      e.preventDefault();

      e.stopPropagation();

      setDragOver(false);

      if (disabled || importing) return;

      processList(e.dataTransfer.files);

    },

    [disabled, importing, processList]

  );



  const busy = disabled || importing || generatingImage;



  const isHud = variant === 'hud';

  return (
    <Box
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled && !importing) setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={onDrop}
      sx={{
        border: '2px dashed',
        borderColor: dragOver ? '#38bdf8' : isHud ? 'rgba(255,255,255,0.12)' : '#cbd5e1',
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        bgcolor: dragOver ? 'rgba(56,189,248,0.08)' : isHud ? '#1e293b' : '#f8fafc',
        transition: 'border-color 0.15s, background 0.15s',
      }}
    >

      <input

        ref={inputRef}

        type="file"

        hidden

        multiple

        accept={ACCEPT}

        onChange={(e) => {

          processList(e.target.files);

          e.target.value = '';

        }}

      />

      {importing || generatingImage ? (

        <CircularProgress size={28} sx={{ my: 1 }} />

      ) : (

        <InsertPhotoOutlinedIcon sx={{ fontSize: 32, color: isHud ? '#64748b' : '#64748b', mb: 0.5 }} />
      )}
      <Typography variant="body2" sx={{ mb: 1, color: isHud ? '#94a3b8' : 'text.secondary' }}>

        Arraste aqui <strong>PPTX</strong>, <strong>PNG</strong>, JPG, GIF ou WebP

      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>

        <Button

          variant="outlined"

          size="small"

          startIcon={<CloudUploadIcon />}

          disabled={busy}

          onClick={() => inputRef.current?.click()}

          sx={{ textTransform: 'none' }}

        >

          Selecionar arquivos

        </Button>

        {onGerarImagem && (

          <>

            <Button

              variant="contained"

              size="small"

              startIcon={generatingImage ? <CircularProgress size={14} color="inherit" /> : <AutoAwesomeIcon />}

              disabled={busy}

              onClick={onGerarImagem}

              sx={{

                textTransform: 'none',

                bgcolor: '#0f172a',

                '&:hover': { bgcolor: '#1e293b' },

              }}

            >

              {generatingImage ? 'Gerando ilustração...' : 'Gerar ilustração com IA'}
            </Button>
            {showIlustracaoHint && (
              <Typography variant="caption" color="text.secondary" sx={{ maxWidth: 280, lineHeight: 1.35 }}>
                Requer plano pago no Google AI Studio. Gráficos de dados funcionam no plano gratuito.
              </Typography>
            )}
          </>
        )}

      </Box>

    </Box>

  );

}

